// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "a[data-v-98ee4040]{text-decoration:none;color:#8d9ea8;font-size:17px;line-height:22px}.user-area[data-v-98ee4040]{line-height:1;text-align:center;display:flex;flex-direction:column}.user-area a[data-v-98ee4040]{font-size:14px}.button-primary[data-v-98ee4040]{border-color:#158ad2;background-color:#158ad2;color:#fff;box-sizing:border-box;border-radius:22px;padding:10px 25px;margin-bottom:19px;min-width:220px}", ""]);
// Exports
module.exports = exports;
